import { useAtomValue } from 'jotai';
import {
  errorPlanInfoAtom,
  loadingPlanInfoAtom,
  planInfoAtom,
} from './plan.state';

export const usePlan = () => {
  const planInfo = useAtomValue(planInfoAtom);
  const loadingPlanInfo = useAtomValue(loadingPlanInfoAtom);
  const errorPlanInfo = useAtomValue(errorPlanInfoAtom);

  return {
    planInfo,
    loadingPlanInfo,
    errorPlanInfo,
  };
};
